module.exports = __webpack_public_path__ + "img/icons/new/trash-b9274674bebb43be5f982fd3c54ce301.svg";